"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SiteLogo = void 0;
var React = __importStar(require("react"));
var react_1 = require("@chakra-ui/react");
var useIsMobile_1 = require("../hooks/useIsMobile");
var DEFAULT_COLOR = '#FF3D33';
var ICON_SIZE = '28px';
var LOGO_AREA_WIDTH = '130px';
var LOGO_AREA_HEIGHT = '50px';
var SiteLogo = function (_a) {
    var LinkComponent = _a.LinkComponent, url = _a.url, title = _a.title, _b = _a.color, color = _b === void 0 ? DEFAULT_COLOR : _b;
    var isMobile = (0, useIsMobile_1.useIsMobile)();
    return (React.createElement(LinkComponent, { href: "/", className: "header-logo", _hover: { textDecoration: 'none' }, "data-feature-id": "header_logo", width: LOGO_AREA_WIDTH, height: LOGO_AREA_HEIGHT }, url ? (React.createElement(react_1.Image, { src: url, width: LOGO_AREA_WIDTH, height: LOGO_AREA_HEIGHT, objectFit: "contain", padding: 2 })) : (React.createElement(react_1.Flex, { align: "center", justify: "center", width: LOGO_AREA_WIDTH, height: LOGO_AREA_HEIGHT },
        React.createElement(react_1.Box, { bg: color, minWidth: ICON_SIZE, minHeight: ICON_SIZE, marginRight: "8px" }),
        React.createElement(react_1.Heading, { as: "h1", fontSize: isMobile ? 'xl' : '2xl', noOfLines: 1, color: color, m: 0, p: 0, minHeight: 0 }, title)))));
};
exports.SiteLogo = SiteLogo;
